module.exports = __webpack_public_path__ + "img/cake.73e05bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BI/cake.png
// module id = 1768
// module chunks = 137